












import {Component, Vue} from 'vue-property-decorator';
import getClientType from '@/lib/getClient.ts';

@Component
export default class QRCode extends Vue {
  flag = true;
  flagOff = false;
  clientType = getClientType();

  // 计算客户端宽度 是否展示 二维码
  get isShowQRCode() {
    if (this.clientType === 'PC' && !this.flagOff) {
      this.flag = true;
    } else if (this.flagOff) {
      this.flag = false;
    } else if (this.clientType === 'mobile') {
      this.$emit('updateMask');
      this.flag = false;
    }
    return this.flag;
  }

  hideMask() {
    this.$emit('updateMask');
  }
}
